const GATEWAY_URL = 'https://back-erp.agrosilo-solutions.com/';
const CLIENT_URL = 'https://back-erp.agrosilo-solutions.com/';
const DOCUMENT_URL = 'https://back-erp.agrosilo-solutions.com/';
const FOURNISSEUR_URL = 'https://back-erp.agrosilo-solutions.com/';
const PARAMETRE_URL = 'https://back-erp.agrosilo-solutions.com/';
const PRODUCT_URL = 'https://back-erp.agrosilo-solutions.com/';
const LOGICIEL_CAISSE_URL = 'https://back-logiciel-caisse.agrosilo-solutions.com/';
const LOGICIEL_CAISSE_FRONT_URL = 'https://front-logiciel-caisse.agrosilo-solutions.com/';

export const environment = {
  production: true,
  hmr: false,
  currentModule: 'hub',
    hubUrl: 'https://front-hub.agrosilo-solutions.com',
  erpModules: [
    {
      id: 'vente',
      title: 'Vente',
      description: 'Devis, commandes clients, factures, bons de livraison et POS.',
      icon: 'dollar-sign',
      color: '#134AD3',
      baseUrl: 'https://front-vente.agrosilo-solutions.com',
      defaultRoute: '/dashboards'
    },
    {
      id: 'achat',
      title: 'Achat',
      description: 'Commandes fournisseurs, bons de réception et factures achat.',
      icon: 'shopping-cart',
      color: '#0B8FA8',
        baseUrl: 'https://front-achat.agrosilo-solutions.com',
      defaultRoute: '/dashboards'
    },
    {
      id: 'remise_promotion',
      title: 'Remise et promotion',
      description: 'Remises, promotions et référentiels partagés (clients, produits).',
      icon: 'tag',
      color: '#9C27B0',
      baseUrl: 'https://front-remise-promotion.agrosilo-solutions.com',
      defaultRoute: '/dashboards'
    },
    {
      id: 'comptabilite',
      title: 'Trésorerie',
      description: 'Trésorerie, banque, chèques et gestion de stock.',
      icon: 'credit-card',
      color: '#1F8A5B',
      baseUrl: 'https://front-comptabilite.agrosilo-solutions.com',
      defaultRoute: '/dashboards'
    },
    {
      id: 'parametre',
      title: 'Paramètres',
      description: 'Entreprise, documents, taxes, utilisateurs, caisse et intégrations.',
      icon: 'settings',
      color: '#020626',
      baseUrl: 'https://front-parametrage.agrosilo-solutions.com',
      defaultRoute: '/main/parametre/entreprise'
    },
    {
      id: 'parametre_data',
      title: 'Paramètres données',
      description: 'Configuration des produits, clients, fournisseurs et référentiels.',
      icon: 'database',
      color: '#C47A1A',
      baseUrl: 'https://front-paramatrage-donne.agrosilo-solutions.com',
      defaultRoute: '/main/parametre/donnees/produits'
    },
    {
      id: 'gestion_stock',
      title: 'Gestion stock',
      description: 'Stocks, transferts entrepôts, clients, fournisseurs, produits et gammes.',
      icon: 'layers',
      color: '#C23B3C',
      baseUrl: 'https://front-gestion-stock.agrosilo-solutions.com',
      defaultRoute: '/gestion-stock/actif'
    }
  ],
  apiUrl: GATEWAY_URL,
  client_url: CLIENT_URL,
  document_url: DOCUMENT_URL,
  fournisseur_url: FOURNISSEUR_URL,
  parameters_url: GATEWAY_URL,
  parametrage_url: PARAMETRE_URL,
  product_url: PRODUCT_URL,
  stock_url: GATEWAY_URL,
  notifications_url: GATEWAY_URL,
  paiement_url: GATEWAY_URL,
  tresorerie_url: GATEWAY_URL,
  transfertsEntrepotsErpBaseUrl: LOGICIEL_CAISSE_URL,
  api_logiciel_caisse: LOGICIEL_CAISSE_URL,
  logiciel_caisse_front_url: LOGICIEL_CAISSE_FRONT_URL,
  static_code_entreprise: '001',
  file_url: '../assets/images/logo/logo.png',
  image_url: '../assets/images/logo/',
  url_images: 'https://back-erp.agrosilo-solutions.com',
};
